import React from 'react';
import posthog from 'posthog-js';
import Package from '../../../../package.json';
import { ArrayHelpers, Footer, Loading } from 'e4shared';

import './zero.css';
import 'e4shared/lib/shared-bundle.css';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromLocalStorage } from 'actions/user';

import DebugHelper from 'components/debugHelper';

export const Zero = ({ children, history, match }) => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user.user);
    const { text } = useSelector(state => state.ui);

    const id = match.params.guid;

    React.useEffect(() => {
        if (!user && !id) {
            dispatch(loadUserFromLocalStorage(history));
        }
    }, []);

    React.useEffect(() => {
        if (user?.id && ArrayHelpers.existsAndHasLength(text)) {
            document.TRANSLATIONS = text;
            posthog.identify(user.unique_Id);
            posthog.capture('zero-review');
            posthog.capture('$set', {
                $set: {
                    roles: user.role_Names,
                    subdomain: user.subDomain,
                    region: 'EU',
                },
            });
        }
    }, [text, user]);

    const logoFull = 'richardson-logo-full.svg';

    return (
        <div id="zero">
            <header className="main-header">
                <div className="flex flex-center">
                    <div className="logo">
                        <span className="logo-lg pt3 pull-left">
                            <img
                                src={`/dist/img/${logoFull}`}
                                style={{ width: '150px', height: '24px' }}
                                alt=""
                                loading="lazy"
                            />
                        </span>
                    </div>
                    <div className="text-right flex-grow no-wrap mr20 header-name">{user?.full_Name}</div>
                </div>
            </header>
            <div className="zero-wrapper">
                <div>{user || id ? children : <Loading />}</div>
            </div>
            <DebugHelper />
            <Footer version={Package.version} />
        </div>
    );
};

export default Zero;
